import { useEffect } from "react";

/** Rola suavemente até a seção montada, respeitando o cabeçalho fixo (scroll-mt-*). */
export const scrollToSection = (node) => {
  if (!node) return;
  requestAnimationFrame(() => {
    node.scrollIntoView({ behavior: "smooth", block: "start" });
  });
};

/** Rola até o elemento quando `active` fica verdadeiro (ou muda de valor). */
export const useScrollIntoViewWhen = (ref, active) => {
  useEffect(() => {
    if (!active || !ref.current) return;
    scrollToSection(ref.current);
  }, [ref, active]);
};
